import classNames from 'classnames';
import React from 'react';

import AppIconIcon from './AppIcon.svg?react';

export const AppIcon: React.FC<{
  className?: string;
}> = ({ className }) => {
  return <AppIconIcon className={classNames(className)} />;
};
